import React, { useState } from 'react'; // Importe useState
import { motion } from 'framer-motion';
import { GiGrandPiano } from "react-icons/gi";
import { SlMusicTone } from "react-icons/sl"; // Se você não usa SlMusicTone, pode remover

import '../../../assets/css/apresenta.css';

const ApresentacaoWaldir = () => {
    // Estado para controlar a expansão/encurtamento do texto
    const [isTextExpanded, setIsTextExpanded] = useState(false);

    const titleVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                ease: "easeOut"
            }
        }
    };

    const textVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.3
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 10 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5 }
        }
    };

    // Variações para as imagens
    const imageVariants = {
        hidden: { opacity: 0, scale: 0.8, rotate: -5 },
        visible: {
            opacity: 1,
            scale: 1,
            rotate: 0,
            transition: {
                duration: 0.8,
                ease: "easeOut"
            }
        }
    };

    // Mantenha os textos originais, não os altere
    const textBlock1Paragraph1 = `Assim se resume a história de Waldir Pianos, que ficou assim conhecido ao se tornar referência em reformas e lustrações em São Paulo, prestando estes serviços para as principais lojas da cidade e atendendo diversos clientes que se tornaram verdadeiros amigos ao longo de mais de meio século.`;
    const textBlock1Paragraph2 = `Tudo começou em 1968, após conclusão de curso de pintor de móveis no SENAI, Waldir ingressou como auxiliar geral na fábrica de pianos Zimmermann, onde teve seu primeiro contato com o instrumento que se tornaria sua paixão.`;
    const textBlock2Paragraph1 = `Por lá, desenvolveu verdadeiro fascínio por cada componente e após pouco mais de 05 anos de conhecimentos adquiridos fundou a sua própria oficina de reformas atendendo inicialmente lojistas e parceiros e pouco depois o público amante de música com reformas completas, consideradas verdadeiras obras de arte estéticas e musicais tamanha excelência e paixão aplicada no serviço.`;
    const textBlock2Paragraph2 = `Trabalhando com idoneidade, estabeleceu parceirias sólidas com os principais profissionais técnicos de sua época para oferecer soluções completas quando o assunto é restauração.`;
    const conclusionParagraph = `Hoje todo conhecimento é passado de pai para filhos, aliando um legado de décadas de experiência às novidades que a tecnologia proporciona até mesmo para um instrumento musical tão tradicional. E é este encontro de gerações unindo a paixão pela profissão, união de família, atualização constante sem perder a essencialidade que faz da Reformadora de Pianos Waldir sua melhor escolha para comprar, reformar e descupinizar.`;


    return (
        <div className='container-apresentacao-waldir'>
            <motion.div
                className="title-wrapper"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-100px" }}
                variants={titleVariants}
            >
                <div className='h2-cor'>Uma vida dedicada aos pianos</div>
 <img 
        src="/img/slides/56_anos.webp" 
        alt="+56 anos" 
        className="imagem-h2-mobile" 
    />
                <GiGrandPiano className="piano-icon" />
            </motion.div>

            <div className="text-blocks-container">
                {/* BLOCO DE TEXTO 1 e 2 encapsulados para o botão "Leia Mais" */}
                <motion.div
                    className="text-block" // Este é o primeiro (e único) text-block para o conteúdo principal
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-50px" }}
                    variants={textVariants}
                >
                    {/* Wrapper para os textos controlados pelo "Leia Mais" */}
                    <div className={`text-container-mobile ${isTextExpanded ? 'expanded' : ''}`}>
                        {/* Conteúdo do Bloco 1 */}
                        <motion.img
                            src="/img/historia/waldir-historia01.jpg" // Certifique-se de ter esta imagem
                            alt="Waldir Pianos Reformadora de Pianos"
                            className="text-float-image right-float"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.5 }}
                            variants={imageVariants}
                        />
                        <motion.p variants={itemVariants}>
                            {textBlock1Paragraph1}
                        </motion.p>
                        <motion.p variants={itemVariants}>
                            {textBlock1Paragraph2}
                        </motion.p>

                        {/* Conteúdo do Bloco 2 */}
                        <motion.img
                            src="/img/historia/waldir-historia02.webp" // Certifique-se de ter esta imagem
                            alt="Waldir Pianos e Filho"
                            className="text-float-image left-float"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.5 }}
                            variants={imageVariants}
                        />
                        <motion.p variants={itemVariants}>
                            {textBlock2Paragraph1}
                        </motion.p>
                        <motion.p variants={itemVariants}>
                            {textBlock2Paragraph2}
                        </motion.p>

                                 <motion.div
                className="conclusion-block"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.4 }}
            >
                <p>
                    {/* Nova Imagem no Bloco de Conclusão */}
                    <motion.img
                        src="/img/historia/waldir-historia03.webp" // Certifique-se de ter esta imagem
                        alt="Pianos Waldir Conclusão"
                        className="conclusion-float-image" // Nova classe para esta imagem
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.5 }}
                        variants={imageVariants} // Reutiliza as variantes de animação
                    />
                    {conclusionParagraph}
                </p>
            </motion.div>
                    </div>

                    {/* Botão "Leia Mais/Ver Menos" visível SOMENTE no celular */}
                    <button
                        className="read-more-button"
                        onClick={() => setIsTextExpanded(!isTextExpanded)}
                    >
                        {isTextExpanded ? 'Ver Menos' : 'Leia Mais'}
                    </button>
                </motion.div>
                {/* O segundo .text-block foi removido ou seu conteúdo foi incorporado acima,
                    pois o "Leia Mais" controlará todo o conteúdo em um único bloco.
                    Se você realmente precisa de duas colunas, a estrutura do "Leia Mais"
                    teria que ser mais complexa ou se aplicar por bloco.
                    Mantive a estrutura anterior que agrupa os dois blocos para fins do "Leia Mais".
                */}

                
            </div>

         
   
        </div>
    );
};

export default ApresentacaoWaldir;